import {Navigate, Outlet, useSearchParams} from 'react-router-dom'
import {routes} from '@/utilities/constants/routes.tsx'
import {useAuthStore} from '@/features/auth/store/store.ts'

export const PublicRoute = () => {
    const accessToken = useAuthStore(state => state.accessToken)
    const [searchParams] = useSearchParams()

    if (accessToken) {
        // Honour a post-login `redirect`, but only for internal absolute paths
        // (avoids open-redirect to external URLs). Falls back to the dashboard.
        const redirect = searchParams.get('redirect')
        const safeRedirect = redirect && redirect.startsWith('/') && !redirect.startsWith('//') ? redirect : null

        return <Navigate to={safeRedirect ?? routes.DASHBOARD.path} replace />
    }

    return <Outlet />
}
